import { OPTIONAL_ITEMS, type OptionalItem } from '@witmetrics/unison-core';

export const classes = {
  toggleBlock: 'shrink-0',
  label: 'ml-2',
};

export function getValue(
  showCompare: boolean,
  showIpr: boolean,
  showAttachments: boolean
): OptionalItem[] {
  let result: OptionalItem[] = [];
  if (showCompare) result.push(OPTIONAL_ITEMS.COMPARE);
  if (showIpr) result.push(OPTIONAL_ITEMS.IPR);
  if (showAttachments) result.push(OPTIONAL_ITEMS.ATTACHMENTS);
  return result;
}
